;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"0200e8ba891c6d07cb476535400c2f815b0fcd47"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/fem";import * as Sentry from '@sentry/nextjs'
import {getEnvironment, SENTRY_TRACES_SAMPLE_RATE} from 'sentry.utils'
import {env} from '~/config/env.mjs'
import {isProd} from '~/config/nodeEnv'

Sentry.init({
  dsn: env.NEXT_PUBLIC_SENTRY_DSN,
  debug: false,
  enabled: isProd,
  environment: getEnvironment(),
  tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
  integrations: [
    Sentry.replayIntegration({
      blockAllMedia: false,
    }),
    Sentry.thirdPartyErrorFilterIntegration({
      // Specify the application keys that you specified in the Sentry bundler plugin
      filterKeys: ['mercury-fem'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 0.1,
})
